import React from "react";

import tw, { css } from "twin.macro";
import { COLORS } from "../../../libs/globals";

import Button from "./BaseButton";

const TextButton = ({
	color = `BLUE`,
	icon,
	text,
	onClick,
	type,
}) => {
	return (
		<Button
			bg={COLORS[color].cardButton}
			onClick={onClick}
			type={type}
		>
			<div
				css={[
					tw`
					flex items-center
					font-centra text-base
					`,
				]}
			>
				<span>{text}</span>
				{icon && (
					<span css={[tw`pl-2 fill-current`]}>
						{icon}
					</span>
				)}
			</div>
		</Button>
	);
};

export default TextButton;
